export default {
  buttons: {
    reschedule: '重新安排',
    'reschedule-change-address': '重新安排/更改地址',
    'add-time': '增加时间',
  },
  'pickup-time-min-title': '最早取件时间',
  'pickup-time-max-title': '最晚取件时间',
  'pickup-date': '选择送货日期',
  'change-address': {
    title: '您已更改地址',
    description: '请稍等，我们将处理您的订单并提供追踪链接。',
    error: '抱歉，我们不配送到该地址，请输入其他地址。',
  },
  'coolbox-modal': {
    message: '您的药品配送受时间限制。<br>您确定要重新安排送货日期吗？',
    rescheduleButton: '是，重新安排',
    cancelButton: '取消',
  },
  'next-day-window': '次日 8:00am-9:00pm',
}
